import { ApiBase } from '@/api/methods/ApiBase'
import { ApiResponseUserStudentInformation, ApiResponseUser } from '@/api/responses/users'

export namespace UsersApi {
  /**
   * ユーザ取得API
   *
   * @param userId ユーザID
   * @returns ユーザ情報
   */
  export async function getUser(userId: number): Promise<ApiResponseUser> {
    return await ApiBase.get(`users/${userId}`)
  }

  /**
   * 生徒情報取得
   *
   * @param userId ユーザID
   * @returns 生徒情報
   */
  export async function getStudentInformation(userId: number): Promise<ApiResponseUserStudentInformation> {
    return await ApiBase.get(`users/student/${userId}`)
  }

  /**
   * 生徒情報更新
   *
   * @param userId ユーザID
   * @param avatarIconCode アバターアイコンコード
   */
  export async function updateStudent(userId: number, avatarIconCode: string): Promise<void> {
    const params = {
      avatarIconCode: avatarIconCode,
    }
    await ApiBase.post(`users/student/${userId}/update`, params)
  }

  /**
   * パスワード変更
   *
   * @param currentPassword 現在のパスワード
   * @param newPassword 新規パスワード
   */
  export async function updatePassword(currentPassword: string, newPassword: string): Promise<void> {
    const params = {
      currentPassword: currentPassword,
      newPassword: newPassword,
    }
    await ApiBase.post(`users/password/update`, params)
  }

  /**
   * パスワード変更(変更必須時)
   *
   * @param newPassword 変更後パスワード
   */
  export async function updatePasswordForce(newPassword: string): Promise<void> {
    const params = {
      newPassword: newPassword,
    }
    await ApiBase.post('users/password/update/force', params)
  }
}
